export const SET_CURRENCY = 'SET_CURRENCY';
